export default "__VITE_ASSET__b5c4b7fa__"